import { useState } from "react";
import { Chart, registerables } from "chart.js";
import "chartjs-adapter-moment";
import annotationPlugin from "chartjs-plugin-annotation";
// Components
import {
  GraphicContainer,
  GraphicRotateDiv,
  HeaderDiv,
  MaximizeGraphicButton,
  MaximizeGraphicImg,
  GraphicTitle,
  ReactTooltipStyled,
  InfoButton,
  InfoImg,
  BetaTitle,
  AxisAndGraphicDiv,
  AxisYSizeDiv,
  AxisY,
  GraphicSizeDiv,
  AxisX,
} from "./styles";
// Assets
import IcoInfoImg from "../../assets/icons/ico_info.svg";
import MaximizeImg from "../../assets/icons/ico_maximize_graphic.svg";
import MinimizeImg from "../../assets/icons/ico_minimize_graphic.svg";

const Graphic = ({
  Title,
  Type,
  data,
  axisY,
  axisX,
  min = false,
  max = false,
  annotation = {},
  graphicDescription = "",
  isBeta = false,
  height = "200px",
  paramScales = false,
  margin = "20px auto",
  indexAxis = "x",
  showLegend = true,
  forceHideLegend = false,
  legend = null,
  shadow = "0 5px 15px rgb(0 0 0 / 10%)",
}) => {
  Chart.register(...registerables, annotationPlugin);
  const [maximizeActive, setMaximizeActive] = useState(false);
  const handleSetMaximizeActive = () => setMaximizeActive(!maximizeActive);

  const renderScales = () => {
    const defaultScales = {
      y: {
        beginAtZero: true,
      },
      x: {
        beginAtZero: true,
      },
    };
    let scales = paramScales ? paramScales : defaultScales;
    if (min) scales.y.min = min;
    if (indexAxis === "x" && max) scales.y.max = max;
    if (indexAxis === "y" && max) scales.x.max = max;
    return scales;
  };

  const shouldDisplayLegend = () => {
    if (showLegend) return true;
    return data?.datasets?.filter((ds) => ds.label)?.length > 1;
  };

  const renderChart = () => {
    return (
      <Type
        data={data}
        options={{
          clip: false,
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: forceHideLegend ? false : shouldDisplayLegend(),
              labels: {
                usePointStyle: true,
                filter: (legendItem, chartData) => {
                  let entries = chartData.datasets.map((e) => e.label);
                  return entries.indexOf(legendItem.text) === legendItem.datasetIndex;
                },
              },
            },
            annotation: annotation,
          },
          indexAxis: indexAxis,
          scales: renderScales(),
        }}
      />
    );
  };

  return (
    <GraphicContainer maximizeGraphic={maximizeActive} margin={margin} shadow={shadow}>
      <GraphicRotateDiv maximizeGraphic={maximizeActive}>
        <HeaderDiv padding={graphicDescription ? "" : "0 0 0 28px"}>
          <GraphicTitle>{Title}</GraphicTitle>
          {graphicDescription && (
            <>
              <InfoButton data-for="graphicInfoButton" data-tip={graphicDescription}>
                <InfoImg src={IcoInfoImg} alt="ico-info" />
              </InfoButton>
              <ReactTooltipStyled id="graphicInfoButton" place="top" type="dark" effect="solid" delayShow={100} delayHide={100} />
              {isBeta && <BetaTitle>Beta</BetaTitle>}
            </>
          )}
        </HeaderDiv>
        <MaximizeGraphicButton onClick={handleSetMaximizeActive}>
          <MaximizeGraphicImg src={maximizeActive ? MinimizeImg : MaximizeImg} alt="btn-max-min-graphic" maximizeGraphic={maximizeActive} />
        </MaximizeGraphicButton>
        {legend}
        <AxisAndGraphicDiv height={height}>
          <AxisYSizeDiv>
            <AxisY>{axisY}</AxisY>
          </AxisYSizeDiv>
          <GraphicSizeDiv>{renderChart()}</GraphicSizeDiv>
        </AxisAndGraphicDiv>
        <AxisX>{axisX}</AxisX>
      </GraphicRotateDiv>
    </GraphicContainer>
  );
};

export default Graphic;
